import {Building2} from 'lucide-react';

/**
 * Main navigation of an agency workspace: it manages workspaces, not content.
 * Deliberately a single entry — the user's other workspaces are already
 * reachable from the switcher, so an "All my workspaces" item would just
 * duplicate it.
 */
export const useAgencyNavigation = (workspaceBaseUrl: string) => {
  return [
    {
      title: 'Client workspaces',
      url: `${workspaceBaseUrl}/agency`,
      icon: Building2,
    },
  ];
};
